import { useGetDependenciesMutation } from '../api/useWorkspaces';

export const useWorkspaceDependenciesApi = () => {
  const { trigger: runGetDependencies, ...getDependenciesResponse } = useGetDependenciesMutation();
  const { isLoading, isSuccess, data } = getDependenciesResponse;

  const getDependencies = async (
    workspaceID: number,
    direction: 'upstream' | 'downstream' | 'any',
    excludeSelf: boolean,
  ) => {
    await runGetDependencies({ workspaceID, direction, excludeSelf });
  };

  return {
    getDependencies,

    areDependenciesLoading: isLoading,
    wasGetDependenciesSuccessful: isSuccess,
    workspaceDependencies: data ? [...(data.upstreamDependencies ?? []), ...(data.downstreamDependencies ?? [])] : [],
  };
};
